module.exports = __webpack_public_path__ + "static/img/2.3432780.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/2.jpg
// module id = RpFd
// module chunks = 5